import { Box, Flex, Text, Badge, HTMLChakraProps, SkeletonText, Skeleton, forwardRef } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { RelativeTimestamp } from '@/components/ui/core/RelativeTimestamp/RelativeTimestamp';
import { Notification } from '@/resources/Notification';

export interface INotificationItemProps extends HTMLChakraProps<'div'> {
  notification: Notification;
}

export const NotificationItem: FC<INotificationItemProps> = forwardRef<INotificationItemProps, 'div'>(
  function NotificationItem({ notification, ...rest }, ref) {
    const { t } = useTranslation();

    return (
      <Flex
        ref={ref}
        alignItems="center"
        justifyContent="space-between"
        p={3}
        _hover={{ bgColor: 'gray.50' }}
        borderRadius={2}
        {...rest}
      >
        <Box mr={{ base: 4, md: 6, lg: 4 }} flex="1 1 100%">
          <Text mb={2} fontSize="sm" lineHeight="5" fontWeight="normal">
            {`${t(`notifications.${notification.type}`)} `}
            <Text as="span" fontWeight="bold">
              {notification?.lecture?.title}
            </Text>
          </Text>
          <RelativeTimestamp
            as={Text}
            color="gray.700"
            fontSize="xs"
            lineHeight="1rem"
            fontFamily="heading"
            timestamp={new Date(notification.createdAt)}
          >
            {(formatedTimestamp) =>
              t('notifications.relativeTimestamp', {
                time: formatedTimestamp,
              })
            }
          </RelativeTimestamp>
        </Box>
        {!notification.read && <Badge size="sm" flex="1 0 auto" />}
      </Flex>
    );
  }
);

export const NotificationItemSkeleton: FC<HTMLChakraProps<'div'>> = (props) => {
  return (
    <Box w="full" p={3} {...props}>
      <SkeletonText noOfLines={3} skeletonHeight={4} mb={4} />
      <Skeleton w={10} h={4} />
    </Box>
  );
};
